import { Plan } from "../../models";

export const deletePlan = async (
    API_URL: string,
    employerId: string,
    token: string,
    plan: Plan
  ) => {
    const response = await fetch(
      `${API_URL}/employers/${employerId}/plans/${plan.id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    if (!response.ok) {
      if (response.status === 409) {
        throw new Error(
          "There was a problem deleting this Plan. To delete a plan, it must not be assigned to any employees."
        );
      }
      throw new Error("There was a problem deleting this Plan.");
    }
  }